import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import BaseRule from '../BaseRule.vue';
import { computed } from 'vue';
export default {
  __name: 'TotalOverdue',
  props: ['index', 'item'],
  setup(__props) {
    const props = __props;
    const index = computed(() => props.index);
    const item = computed(() => props.item);
    const word = {
      name: 'TotalOverdue'
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      return _openBlock(), _createBlock(BaseRule, {
        word: word,
        index: _unref(index)
      }, {
        default: _withCtx(() => [_createTextVNode(" 近"), _createVNode(_component_el_input, {
          modelValue: _unref(item).value.one,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(item).value.one = $event),
          class: "input"
        }, null, 8, ["modelValue"]), _createTextVNode("月，累积逾期小于 "), _createVNode(_component_el_input, {
          modelValue: _unref(item).value.two,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(item).value.two = $event),
          class: "input"
        }, null, 8, ["modelValue"]), _createTextVNode("次 "), _createVNode(_component_el_checkbox, {
          label: "贷款",
          class: "overdueSelected",
          modelValue: _unref(item).value.three,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(item).value.three = $event)
        }, null, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
          label: "信用卡",
          class: "overdueSelected",
          modelValue: _unref(item).value.four,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(item).value.four = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["index"]);
    };
  }
};